<template>
  <section>
    <p class="gp-section-title">
      <span>{{ position }}</span
      >Dachränder
    </p>

    <div class="g-pb-10" v-if="description">
      <p class="gea-two-column-description">
        {{ description }}
      </p>
    </div>

    <div class="gp-2-column">
      <div class="gp-left-column">
        <div class="g-pr-16">
          <roof-image></roof-image>
        </div>
        <section-content :title="mainTitle" :body="texts['3.1']"></section-content>
      </div>

      <div class="gp-right-column">
        <div class="gp-dachraender">
          <div class="g-border g-border-grey-200 g-bg-white g-mb-4" v-for="(side, index) of sides" :key="side.id + index">
            <div class="g-flex g-overflow-hidden g-rounded-t g-border-b g-border-grey-200">
              <div class="g-bg-green-500 g-text-white g-font-bold g-w-28 g-py-2 g-px-4">{{ side.name }}</div>
            </div>

            <div
              class="g-flex g-items-center g-border-b g-border-grey-200"
              v-for="(option, index) of dachrandOptions"
              :key="option.name + index"
              v-show="!side.collapsed || optionIsSelected(option, side)"
              @click="selectOption(option, side)"
            >
              <div class="g-p-4">
                <img :src="option.image" :alt="option.name" style="width: 120px; height: 120px" />
              </div>
              <div class="g-pr-4" style="flex-grow: 1">
                <p class="g-font-bold">{{ option.name }}</p>
                <p v-if="option.description">{{ option.description }}</p>

                <div v-if="option.editable" class="g-pt-1 g-pb-2">
                  <div class="g-flex g-justify-between">
                    <label for="breite" class="">Höhe</label>
                    <p class="g-text-grey-600">in Zentimetern</p>
                  </div>
                  <input
                    type="text"
                    name="Höhe"
                    class="g-border g-rounded g-border-gray-300 g-p-2 mg-b-1 g-w-full"
                    :value="side.values[option.position] || ''"
                    @input="updateOptionValue(option, side, $event)"
                  />
                </div>
              </div>
            </div>
            <div class="g-flex g-items-center g-py-2 g-px-5 g-border-t g-border-grey-200 g-cursor-pointer">
              <gp-icon
                :icon="['fas', 'arrow-down']"
                class="g-text-white g-bg-green-500 g-opacity-50 g-rounded-sm g-p-[2px]"
                :style="{
                  transform: 'scale(1.7, 1.6)',
                }"
              />
              <p class="g-ml-4 g-text-grey-900" @click="toggleSideOptions(side)">Weitere Optionen anzeigen</p>
            </div>
          </div>
        </div>

        <div v-if="randProfilSelected.length">
          <p class="gp-option-list-title">Farbe</p>

          <div class="g-flex g-mb-5 g-items-start">
            <div class="g-text-center g-flex g-justify-center g-flex-col g-items-center" @click="selectColor(null)">
              <div
                class="g-flex g-justify-center g-items-center g-w-40 g-h-40 g-bg-white g-border g-border-grey-300 g-mr-3"
                :class="{ 'g-border-green-400 g-border-4': color === null }"
              >
                <gp-icon
                  :icon="['fas', 'ban']"
                  size="lg"
                  :style="{
                    cursor: 'pointer',
                    transform: 'scale(3.5)',
                    color: 'lightgrey',
                  }"
                />
              </div>
              <p class="g-mt-1">Keine Dachränder</p>
            </div>
            <div
              class="g-text-center g-flex g-justify-center g-flex-col g-items-center"
              v-for="item in items"
              :key="item.id"
              @click="selectColor(item.id)"
            >
              <div
                class="g-flex g-justify-center g-items-center g-w-40 g-h-40 g-bg-white g-border g-border-grey-300 g-mr-3"
                :class="{ 'g-border-green-400 g-border-4': color === item.id }"
              >
                <img :src="getImageUrl(item.mainVariationId)" alt="" />
              </div>
              <p class="g-mt-1 g-max-w-xs g-px-4">{{ item.title }}</p>
            </div>
          </div>

          <div v-if="color">
            <p class="gp-option-list-title g-mt-10">Produkte</p>

            <ul class="">
              <li v-for="option of variations" :key="option.id" class="g-flex g-pb-4 g-pt-4 g-border-t-4 g-border-grey-150">
                <div class="g-mr-4 g-bg-white g-flex g-justify-center g-items-center" v-if="images[option.id]">
                  <img class="g-w-24" :src="images[option.id].urlMiddle" />
                </div>

                <div>
                  <p class="g-text-lg g-font-bold" v-if="option">
                    <span>{{ getAttributeValue(option, "Dachrandprofil") }}</span>
                  </p>

                  <p class="g-text-sm">{{ option.texts[0].name1 }}</p>
                  <p class="g-text-lg">{{ getPrice(option) | formatPrice }} EUR</p>
                </div>

                <div class="g-flex g-self-stretch g-items-center g-ml-auto">
                  <quantity-input
                    @change="updateQuantity(option, $event)"
                    :quantity="$store.state.zusammenstellung.basket[option.id] || 0"
                  ></quantity-input>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import RoofImage from "../components/RoofImage.vue";
import SectionContent from "../components/SectionContent.vue";
import { getItemByVariationNumberPrefix } from "../plentyHelpers";
import axios from "axios";
import ENV from "../environment";
import OptionList from "../components/OptionList.vue";
import { getAttributeValue, getPrice } from "../plentyHelpers.js";
import QuantityInput from "../components/QuantityInput.vue";

export default {
  components: { SectionContent, RoofImage, OptionList, QuantityInput },
  name: "Dachraender",

  data() {
    return {
      images: {},
      color: null, // itemID
      sides: [
        {
          name: "Seite A",
          id: "A",
          position: 1,
          choice: 0,
          values: {},
          collapsed: true,
        },
        {
          name: "Seite B",
          id: "B",
          position: 2,
          choice: 0,
          values: {},
          collapsed: true,
        },
        {
          name: "Seite C",
          id: "C",
          position: 3,
          choice: 0,
          values: {},
          collapsed: true,
        },
        {
          name: "Seite D",
          id: "D",
          position: 4,
          choice: 0,
          values: {},
          collapsed: true,
        },
      ],
    };
  },

  async created() {
    await this.$store.dispatch("dachraender/fetchDachrandProfilOptions");
    await this.$store.dispatch("dachraender/fetchDachrandOptions");

    for (const option of this.randProfilOptions) {
      let items = await this.$store.dispatch("zusammenstellung/fetchItems", option.prefix);
      this.fetchImages(items[0].variations);
    }

    // For testing with fixed values
    // setTimeout(() => {
    //   this.sides = [
    //     { name: "Seite A", id: "A", position: 1, choice: 3, values: { 3: "5" }, collapsed: true },
    //     { name: "Seite B", id: "B", position: 2, choice: 3, values: { 3: "6" }, collapsed: true },
    //     { name: "Seite C", id: "C", position: 3, choice: 3, values: { 3: "3" }, collapsed: true },
    //     { name: "Seite D", id: "D", position: 4, choice: 3, values: { 3: "4" }, collapsed: true },
    //   ];
    // }, 1200);
  },

  methods: {
    getPrice,
    getAttributeValue,

    updateOptionValue(option, side, event) {
      this.sides = this.sides.map((s) => {
        if (s.id !== side.id) return s;
        s.values[option.position] = event.target.value;
        return s;
      });
    },

    selectOption(option, side) {
      this.sides = this.sides.map((s) => {
        if (s.id === side.id) {
          s.choice = option.position;
          s.collapsed = true;
        }

        return s;
      });
    },

    optionIsSelected(option, side) {
      return side.choice == option.position;
    },

    toggleSideOptions(side) {
      this.sides = this.sides.map((s) => {
        if (s.id === side.id) s.collapsed = !s.collapsed;
        return s;
      });
    },

    getImageUrl(option) {
      return this.images[option.id]?.urlMiddle;
    },

    updateQuantity(variation, quantity) {
      this.$store.commit("zusammenstellung/setBasketItem", { variationId: variation.id, quantity });
    },

    getImageUrl(variationId) {
      return this.images[variationId]?.urlMiddle;
    },

    async fetchImages(options = this.randProfilOptions) {
      let images = {};

      // Fetch image for each option and store it in the images object
      await Promise.all(
        options.map(async (option, index) => {
          let image = await axios.get(ENV.imageEndpoint + `?itemId=${option.itemId}&pluginSetPreview=${ENV.setPreview}`);
          if (!option.isMain) return (images[option.id] = image.data.images[index - 1]);
          images[option.id] = image.data.images[index];
        })
      );

      this.images = { ...this.images, ...images };
    },

    selectSide(option) {
      let sides = [...this.sides];

      // Deselect all options
      this.sides = sides.map((side) => {
        if (side.id === option.id) {
          side.selected = !side.selected;
          return side;
        }

        return side;
      });
    },

    selectColor(itemId) {
      this.color = itemId;
    },

    updateQuantities() {
      if (!this.variations) return;
      let width = Number(this.width);
      let height = Number(this.depth);
      let totalLength = 0;

      // Set number of Randprofil
      let selectedSides = this.randProfilSelected;

      selectedSides.forEach((side) => {
        if (["A", "C"].includes(side.id)) {
          totalLength += width;
        } else {
          totalLength += height;
        }
      });

      let quantity = Math.ceil(totalLength / 1.95);
      let profileProduct = this.variations.find((variation) => this.getAttributeValue(variation, "Dachrandprofil") == "Randprofil");

      this.$store.commit("zusammenstellung/setBasketItem", { variationId: profileProduct.id, quantity });

      // Set number of Außenecke
      let corners = 0;

      // Check if side A and B are selected
      if (selectedSides.find((side) => side.id == "A") && selectedSides.find((side) => side.id == "B")) corners++;
      if (selectedSides.find((side) => side.id == "A") && selectedSides.find((side) => side.id == "D")) corners++;
      if (selectedSides.find((side) => side.id == "C") && selectedSides.find((side) => side.id == "D")) corners++;
      if (selectedSides.find((side) => side.id == "C") && selectedSides.find((side) => side.id == "B")) corners++;

      let cornerProduct = this.variations.find((variation) => this.getAttributeValue(variation, "Dachrandprofil") == "Außenecke");

      this.$store.commit("zusammenstellung/setBasketItem", { variationId: cornerProduct.id, quantity: corners });

      // Set number of Klickerverbinder
      let klickProduct = this.variations.find((variation) => this.getAttributeValue(variation, "Dachrandprofil") == "Klick-Verbinder");
      let numberOfVerbinder = totalLength > 0 ? Math.ceil(totalLength + 1) : 0;

      this.$store.commit("zusammenstellung/setBasketItem", { variationId: klickProduct.id, quantity: numberOfVerbinder });
    },
  },

  computed: {
    mainTitle() {
      return "Erhöhung des Dachrandes";
    },

    texts() {
      return this.$store.state.inhalt.texts;
    },

    width() {
      return this.$store.state.abmessungen.width;
    },

    depth() {
      return this.$store.state.abmessungen.depth;
    },

    randProfilSelected() {
      let randprofilIndex = this.dachrandOptions.findIndex((option) => option.name.includes("profil"));
      return this.sides.filter((side) => side.choice === randprofilIndex);
    },

    randProfilOptions() {
      if (!this.$store.state.dachraender.randProfilOptions) return [];
      return this.$store.state.dachraender.randProfilOptions;
    },

    dachrandOptions() {
      if (!this.$store.state.dachraender.dachrandOptions) return [];
      return this.$store.state.dachraender.dachrandOptions;
    },

    variations() {
      // Filter out "Innenecke" since its currently not part of the configurator
      return this.items
        .find((item) => item.id === this.color)
        ?.variations?.filter((variation) => !variation.isMain)
        ?.filter((variation) => this.getAttributeValue(variation, "Dachrandprofil") != "Innenecke");
    },

    dachrand() {
      if (!this.variations) return null;
      return this.variations.map((variation) => this.getAttributeValue(variation, "Dachrandprofil"));
    },

    items() {
      return this.randProfilOptions
        .map((option) => {
          let item = getItemByVariationNumberPrefix(this.$store.state.zusammenstellung.items, option.prefix);
          if (!item) return null;
          item.title = option.name;

          return item;
        })
        .filter((item) => item); // filter out nulls;
    },
  },

  props: ["position", "description"],

  watch: {
    sides(updatedSides) {
      // Check if dimensions are effected by the dachrand choices/values
      let addedWidth = 0;
      let addedDepth = 0;

      updatedSides.forEach((side) => {
        let customValue = side.values[side.choice] || 0;
        let fixedAddition = this.dachrandOptions.find((op) => op.position === side.choice).fixedAddition;

        if (["A", "C"].includes(side.id)) addedWidth += Number(customValue) + Number(fixedAddition);
        if (["B", "D"].includes(side.id)) addedDepth += Number(customValue) + Number(fixedAddition);
      });

      console.log({ addedWidth, addedDepth });

      this.$store.commit("abmessungen/setAddedWidth", addedWidth);
      this.$store.commit("abmessungen/setAddedDepth", addedDepth);
    },

    randProfilSelected() {
      this.$nextTick(() => this.updateQuantities());
    },

    width() {
      this.$nextTick(() => this.updateQuantities());
    },

    depth() {
      this.$nextTick(() => this.updateQuantities());
    },

    color() {
      let allVariationIds = this.items
        .map((item) => item.variations)
        .flat()
        .map((variation) => variation.id);

      // Set all products to 0 quantity
      allVariationIds.forEach((variation) => {
        this.$store.commit("zusammenstellung/setBasketItem", { variationId: variation, quantity: 0 });
      });

      this.$nextTick(() => this.updateQuantities());
    },
  },
};
</script>

<style></style>
